import { Puck, Config, FieldLabel, usePuck } from "@measured/puck";
import { Link, useForm, usePage } from "@inertiajs/react";
import "@measured/puck/puck.css";
import { Icon } from "@iconify/react";
import { useEffect, useState } from "react";
import FileUploader from "@/Components/System/FileUploader/FileUploader";
import { RootFields } from "./Fields/RootFields";
import EditorHeader from "./Components/EditorHeader";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import Column from "@/Components/Grid/Column";
import ImageBlock from "./Components/ImageBlock/ImageBlock";
import { AuthorModel } from "@/types/models/AuthorModel";
import { TherapeuticAreaModel } from "@/types/models/TherapeuticAreaModel";
import { TagModel } from "@/types/models/TagModel";
import QuoteBlock from "./Components/QuoteBlock/QuoteBlock";
import TextBlock from "./Components/TextBlock/TextBlock";
import { ArticleModel } from "@/types/models/ArticleModel";
import useUuid from "@/Hooks/useUuid";
import AnnotationBlock from "./Components/AnnotationBlock/AnnotationBlock";
import ButtonBlock from "./Components/ButtonBlock/ButtonBlock";

export const puckConfiguration: Config = {
    components: {
        'Cytat': QuoteBlock,
        'Tekst': TextBlock,
        'Obraz': ImageBlock,
        'Przypisy końcowe': AnnotationBlock,
        'Tekst z przyciskiem': ButtonBlock
    },
    ...RootFields,
};
const Editor = ({ article }: {
    article?: ArticleModel
}) => {
    const [canStoreData, setCanStoreData] = useState<boolean>(false);
    
    const storedAuthors: any[] = []

    article?.authors.map((a, i) => {
        storedAuthors.push({
            id: useUuid(),
            value: a.id
        })
    })

    let storedAreas: string[] = [];

    if (article && article?.therapeutic_areas.length > 0) {
        storedAreas = article.therapeutic_areas.map(th => th.id)
    }

    let storedTags: string[] = [];

    if (article && article.tags.length > 0) {
        storedTags = article.tags.map(tag => tag.id)
    }
    
    const initialData = {
        content: article ? JSON.parse(article.content ? article.content : '[]') : [],
        root: {
            props: {
                title: article?.name,
                readTime: article?.time,
                hero: article?.hero,
                authorsData: storedAuthors,
                therapeuticAreasData: storedAreas,
                tagsData: storedTags,
                expireAt: article?.expire_at,
                status: article?.status,
                excerpt: article?.excerpt,
                article: article,
                showOnPatient: article?.show_on_patient ? String(article.show_on_patient) : '0'
                ,
                isPinProtected: (article as any)?.is_pin_protected ? String((article as any).is_pin_protected) : '0'
            }
        },
        zones: article ? JSON.parse(article.zones ? article.zones : '[]') : []
    };
    
    const { data, setData, post, errors } = useForm<{
        content: string;
        zones: string;
        root: string;
    }>({
        content: '',
        zones: '',
        root: ''
    });

    const save = (data: any) => {
        const contentString = JSON.stringify(data.content);
        const zonesString = JSON.stringify(data.zones);
        const rootString = JSON.stringify(data.root);

        setData((data) = {
            ...data,
            content: contentString,
            zones: zonesString,
            root: rootString
        })

        setCanStoreData(true);

        // post(route('system.articles.updateOrCreate'));
    };

    // const storeCurrentChanges = (data: any) => {
    //     const contentString = JSON.stringify(data.content);
    //     const zonesString = JSON.stringify(data.zones);
    //     const rootString = JSON.stringify(data.root);

    //     setData((data) = {
    //         ...data,
    //         content: contentString,
    //         zones: zonesString,
    //         root: rootString
    //     })
    // }

    useEffect(() => {
        if (canStoreData) {

            post(route('system.articles.updateOrCreate', { article }));

            setCanStoreData(false);
        }
    }, [canStoreData])

    return <Puck
        config={puckConfiguration}
        data={initialData}
        onPublish={save}
        iframe={{ enabled: false }}
        // onChange={storeCurrentChanges}
        overrides={{
            preview: ({ children }) => {
                return (
                    <div className="bg-gradientMain h-full">
                        <EditorHeader />
                        <div className="bg-gradientMain">
                            <Container className="-mt-[30%] relative z-20">
                                <Row className="justify-center ">
                                    <Column xl={10}>
                                        <div className="bg-gradientBackground py-28 min-h-screen">
                                            <Row className="justify-center">
                                                <Column xl={10}>
                                                    {children}
                                                </Column>
                                            </Row>
                                        </div>
                                    </Column>
                                </Row>
                            </Container>
                        </div>
                    </div>
                )
            },
            header: (props) => {
                return (
                    <div className="flex w-screen bg-white gap-x-4 border-b-1 items-center justify-between border-[#dcdcdc]">
                        
                        {(usePage().props.errors.root !== undefined && usePage().props.errors.root != "") &&
                            <div className="w-3/12 text-label text-arcticMist font-semibold bg-crimsonAlert/80 border-crimsonAlert border-[2px] mx-3 self-center px-4 py-2 rounded-lg">
                                {usePage().props.errors.root}
                            </div>
                        }
                        <div className="w-8/12 [&_span]:hidden bg-white">
                            {props.children}
                        </div>
                        <div className="flex items-center px-4 gap-x-4 [&>span]:bg-emeraldPulse bg-white">
                            <Link href={route('system.articles.index')}
                                className="py-[5px] bg-crimsonAlert px-5 rounded text-arcticMist flex items-center">
                                <Icon icon={'pajamas:go-back'} className="mr-2" />
                                <span>
                                    Powrót
                                </span>
                            </Link>
                            {props.actions}
                        </div>
                    </div>
                )
            }
        }}
        headerTitle={article ? `Edycja wpisu - ${article.name}` : 'Dodawanie artykułu'}
    />;
}
export default Editor;
